var Promise = require('when/lib/Promise');

// TODO: Use process.env.NODE_ENV check + envify to enable
// when's promise monitor here when in dev.

module.exports = Promise;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-router/modules/utils/Promise.js
 ** module id = 239
 ** module chunks = 0
 **/